export default {"src":"/_next/static/media/icon_checkbox_off1.284a0923.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};